import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
  hideAttachmentsModal,
  fetchAdjustmentAttachments,
} from '../adjustmentsTab/store/actions';
import {
  fetchingAttachmentsSelector,
  attachmentsSelector,
} from '../adjustmentsTab/store/selectors';

import SingleAttachment from '../../shared/singleAttachment.component';
import Modal from '../../shared/modals/modal.component';

class AttachmentsModal extends PureComponent {
  static propTypes = {
    attachments: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      fileName: PropTypes.string,
      fileType: PropTypes.string,
      fileImage: PropTypes.string,
    })),
    adjustment: PropTypes.shape({
      adjustmentId: PropTypes.number.isRequired,
      description: PropTypes.string.isRequired,
    }),
    hideAttachmentsModal: PropTypes.func.isRequired,
    fetchAdjustmentAttachments: PropTypes.func.isRequired,
    fetchingAttachments: PropTypes.bool.isRequired,
    isVisible: PropTypes.bool,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.adjustment !== this.props.adjustment && this.props.adjustment) {
      this.props.fetchAdjustmentAttachments(this.props.adjustment.adjustmentId);
    }
  }

  render() {
    const {
      hideAttachmentsModal,
      adjustment,
      attachments,
      isVisible,
      fetchingAttachments,
    } = this.props;

    return (
      <Modal
        title="Attachments"
        closeAction={hideAttachmentsModal}
        dismissText="Close"
        dismissAction={hideAttachmentsModal}
        isVisible={isVisible}
        isLoading={fetchingAttachments}
      >
        {adjustment
          ? (
            <div>
              {adjustment.description}<br/><br/>
              {attachments && (
                <span>
                  {attachments.map((attachment, idx) => (
                    <SingleAttachment
                      file={attachment}
                      key={`${attachment.fileName}_${idx}`}
                    />
                  ))}
                </span>
              )}
            </div>
          )
          : null
        }
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  attachments: attachmentsSelector(state),
  fetchingAttachments: fetchingAttachmentsSelector(state),
});

export default connect(
  mapStateToProps,
  {
    hideAttachmentsModal,
    fetchAdjustmentAttachments,
  }
)(AttachmentsModal);
